import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { commandesAPI, getUser, logout } from '../api';
import '../App.css';

const stepLabels = ['Paiement recu', 'Collecte en cours', 'Piece collectee', 'En livraison', 'Livre'];
const stepIcons = ['💳', '🔄', '📦', '🛵', '🏁'];

const statutToStep = {
  'confirme': 0,
  'accepte': 1,
  'collecte': 2,
  'transit': 3,
  'livre': 4,
};

const statutConfig = {
  confirme:   { label: '⏳ Confirme', bg: 'rgba(99,102,241,.12)', color: '#818CF8' },
  accepte:    { label: '✓ Accepte', bg: 'rgba(245,158,11,.12)', color: '#F59E0B' },
  collecte:   { label: '📦 Collecte en cours', bg: 'rgba(245,158,11,.12)', color: '#F59E0B' },
  transit:    { label: '🛵 En livraison', bg: 'rgba(99,102,241,.12)', color: '#818CF8' },
  livre:      { label: '✓ Livre', bg: 'rgba(34,197,94,.12)', color: '#22C55E' },
  annule:     { label: '✗ Annule', bg: 'rgba(239,68,68,.12)', color: '#EF4444' },
};

function DashboardAcheteur() {
  const navigate = useNavigate();
  const user = getUser();
  const [commandes, setCommandes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('all');
  const [openCmd, setOpenCmd] = useState(null);
  const [notifOpen, setNotifOpen] = useState(false);

  useEffect(() => {
    if (!user) { navigate('/connexion'); return; }
    fetchCommandes();
  }, []);

  const fetchCommandes = async () => {
    setLoading(true);
    try {
      const res = await commandesAPI.mesCommandes();
      setCommandes(res.data || []);
      if (res.data?.length > 0) setOpenCmd(res.data[0].id);
    } catch (err) {
      console.error('Erreur chargement commandes:', err);
    } finally {
      setLoading(false);
    }
  };

  const confirmerReception = async (cmdId) => {
    try {
      await commandesAPI.confirmerReception(cmdId);
      fetchCommandes();
    } catch (err) {
      console.error('Erreur confirmation:', err);
    }
  };

  const filtered = commandes.filter(c => {
    if (activeTab === 'all') return true;
    if (activeTab === 'active') return ['confirme', 'accepte', 'collecte', 'transit'].includes(c.statut);
    if (activeTab === 'done') return c.statut === 'livre';
    return true;
  });

  const initials = user ? (user.prenom?.[0] || '') + (user.nom?.[0] || '') : 'U';
  const activeCount = commandes.filter(c => ['confirme','accepte','collecte','transit'].includes(c.statut)).length;
  const doneCount = commandes.filter(c => c.statut === 'livre').length;
  const totalDepense = commandes.reduce((sum, c) => sum + parseFloat(c.total || 0), 0);

  return (
    <div className="app" style={{ display: 'grid', gridTemplateColumns: '230px 1fr', minHeight: '100vh' }}>

      {/* SIDEBAR */}
      <div style={{ background: '#141414', borderRight: '1px solid #2A2A2A', display: 'flex', flexDirection: 'column', position: 'sticky', top: 0, height: '100vh', overflowY: 'auto' }}>
        <div style={{ padding: '20px 20px 16px', borderBottom: '1px solid #2A2A2A' }}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '24px', letterSpacing: '2px', color: '#fff', lineHeight: 1 }}>Tek<span style={{ color: '#F5620A' }}>Teck</span></div>
            <div style={{ fontSize: '9px', fontWeight: '700', color: '#F5620A', letterSpacing: '.5px' }}>rak tak!</div>
          </Link>
        </div>

        <div style={{ padding: '14px 18px', borderBottom: '1px solid #2A2A2A', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ width: '38px', height: '38px', borderRadius: '50%', background: '#F5620A', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '800', fontSize: '13px', color: '#fff', flexShrink: 0 }}>{initials}</div>
          <div>
            <div style={{ fontSize: '13px', fontWeight: '700', color: '#fff' }}>{user?.prenom} {user?.nom}</div>
            <div style={{ fontSize: '11px', color: '#888' }}>Acheteur · {user?.ville}</div>
          </div>
        </div>

        <div style={{ padding: '10px 12px', flex: 1 }}>
          {[
            { icon: '📦', label: 'Mes commandes', active: true, badge: activeCount > 0 ? String(activeCount) : null },
            { icon: '❤️', label: 'Mes favoris' },
            { icon: '🔍', label: 'Catalogue', path: '/catalogue' },
            { icon: '👤', label: 'Mon profil' },
            { icon: '💬', label: 'Messages' },
            { icon: '🛡️', label: 'Litiges' },
          ].map((item, i) => (
            <div key={i} onClick={() => item.path && navigate(item.path)} style={{ display: 'flex', alignItems: 'center', gap: '9px', padding: '9px 10px', borderRadius: '8px', cursor: 'pointer', marginBottom: '2px', background: item.active ? 'rgba(245,98,10,.12)' : 'transparent', border: item.active ? '1px solid rgba(245,98,10,.2)' : '1px solid transparent' }}>
              <span style={{ fontSize: '14px', width: '18px', textAlign: 'center' }}>{item.icon}</span>
              <span style={{ fontSize: '12px', fontWeight: '600', color: item.active ? '#F5620A' : '#888', flex: 1 }}>{item.label}</span>
              {item.badge && <span style={{ background: '#F5620A', color: '#fff', fontSize: '10px', fontWeight: '800', padding: '2px 7px', borderRadius: '8px' }}>{item.badge}</span>}
            </div>
          ))}
        </div>

        <div style={{ padding: '12px 18px', borderTop: '1px solid #2A2A2A' }}>
          <button onClick={logout} style={{ width: '100%', padding: '8px', background: 'transparent', border: '1.5px solid #333', borderRadius: '8px', fontSize: '12px', fontWeight: '700', color: '#888', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
            Deconnexion
          </button>
        </div>
      </div>

      {/* MAIN */}
      <div style={{ overflow: 'auto' }}>
        {/* TOPBAR */}
        <div style={{ background: '#141414', borderBottom: '1px solid #2A2A2A', padding: '0 28px', height: '58px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 50 }}>
          <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '20px', letterSpacing: '1px', color: '#fff' }}>MES COMMANDES</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <button onClick={() => setNotifOpen(!notifOpen)} style={{ position: 'relative', width: '34px', height: '34px', border: '1.5px solid #333', borderRadius: '8px', background: 'transparent', cursor: 'pointer', fontSize: '15px', color: '#fff' }}>
              🔔
              {activeCount > 0 && <div style={{ position: 'absolute', top: '5px', right: '5px', width: '7px', height: '7px', background: '#F5620A', borderRadius: '50%', border: '2px solid #141414' }}></div>}
            </button>
            <Link to="/catalogue"><button className="btn-orange" style={{ fontSize: '12px', padding: '8px 16px' }}>+ Nouvelle commande</button></Link>
          </div>
        </div>

        <div style={{ padding: '22px 28px 60px' }}>

          {/* HEADER AD */}
          <div style={{ marginBottom: '20px' }}>
            <div className="ad-banner-slot">
              <span className="ad-tag">PUB · HEADER</span>
              <span className="ad-price-tag">20 000 F/sem · 72 000 F/mois</span>
              <div className="ad-content">
                <div className="ad-logo">🏥</div>
                <div className="ad-body">
                  <div className="ad-sponsor">ASSISTANCE ROUTIERE SENEGAL</div>
                  <div className="ad-title">En panne ? Assistance 24h/24 — Depannage, remorquage. Abonnement a partir de 15 000 F/an.</div>
                </div>
                <button className="ad-cta">S'abonner</button>
              </div>
            </div>
          </div>

          {/* KPIS */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '12px', marginBottom: '22px' }}>
            {[
              { label: 'COMMANDES TOTALES', val: String(commandes.length), sub: 'depuis votre inscription', subColor: '#888' },
              { label: 'EN COURS', val: String(activeCount), sub: 'livraisons actives', subColor: '#F5620A' },
              { label: 'LIVREES', val: String(doneCount), sub: '✓ completees', subColor: '#22C55E' },
              { label: 'TOTAL DEPENSE', val: totalDepense.toLocaleString('fr-FR'), sub: 'FCFA', subColor: '#888' },
            ].map((k, i) => (
              <div key={i} style={{ background: '#1C1C1C', border: '1px solid #333', borderRadius: '12px', padding: '16px 18px' }}>
                <div style={{ fontSize: '10px', fontWeight: '700', color: '#888', letterSpacing: '.4px', marginBottom: '5px' }}>{k.label}</div>
                <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: i === 3 ? '20px' : '26px', letterSpacing: '1px', color: '#fff', marginBottom: '2px' }}>{k.val}</div>
                <div style={{ fontSize: '11px', fontWeight: '700', color: k.subColor }}>{k.sub}</div>
              </div>
            ))}
          </div>

          {/* FILTRES */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
            <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '20px', letterSpacing: '1px', color: '#fff' }}>COMMANDES</div>
            <div style={{ display: 'flex', gap: '5px' }}>
              {[['all','Toutes'],['active','En cours'],['done','Livrees']].map(([key, label]) => (
                <button key={key} onClick={() => setActiveTab(key)}
                  style={{ padding: '6px 14px', border: `1.5px solid ${activeTab === key ? '#F5620A' : '#333'}`, borderRadius: '20px', fontSize: '11px', fontWeight: '700', cursor: 'pointer', background: activeTab === key ? '#F5620A' : 'transparent', color: '#fff', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                  {label}
                </button>
              ))}
            </div>
          </div>

          {/* LOADING */}
          {loading && (
            <div style={{ textAlign: 'center', padding: '60px 20px' }}>
              <div style={{ fontSize: '32px', marginBottom: '16px' }}>⏳</div>
              <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '20px', color: '#fff' }}>CHARGEMENT...</div>
            </div>
          )}

          {/* EMPTY */}
          {!loading && filtered.length === 0 && (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: '#888' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>📦</div>
              <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '24px', color: '#fff', marginBottom: '8px' }}>AUCUNE COMMANDE</div>
              <div style={{ fontSize: '14px', marginBottom: '20px' }}>Vous n'avez pas encore passe de commande</div>
              <Link to="/catalogue">
                <button className="btn-orange">Parcourir le catalogue</button>
              </Link>
            </div>
          )}

          {/* COMMANDES */}
          {!loading && filtered.map(cmd => {
            const sc = statutConfig[cmd.statut] || statutConfig.confirme;
            const isOpen = openCmd === cmd.id;
            const currentStep = statutToStep[cmd.statut] || 0;

            return (
              <div key={cmd.id} style={{ background: '#1C1C1C', border: `1px solid ${isOpen ? '#F5620A' : '#333'}`, borderRadius: '14px', marginBottom: '12px', overflow: 'hidden' }}>
                {/* HEADER CMD */}
                <div onClick={() => setOpenCmd(isOpen ? null : cmd.id)} style={{ padding: '14px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', gap: '14px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ width: '48px', height: '48px', background: '#141414', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', flexShrink: 0, border: '1px solid #2A2A2A' }}>🔧</div>
                    <div>
                      <div style={{ fontSize: '13px', fontWeight: '700', color: '#fff', marginBottom: '2px' }}>{cmd.nom_piece}</div>
                      <div style={{ fontSize: '11px', color: '#888' }}>{cmd.reference} · {new Date(cmd.created_at).toLocaleDateString('fr-FR')} · {cmd.delai} · {cmd.mobile_money}</div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flexShrink: 0 }}>
                    <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '18px', letterSpacing: '.5px', color: '#F5620A' }}>{parseInt(cmd.total).toLocaleString('fr-FR')} F</div>
                    <span style={{ padding: '3px 10px', borderRadius: '20px', fontSize: '10px', fontWeight: '800', background: sc.bg, color: sc.color, whiteSpace: 'nowrap' }}>{sc.label}</span>
                    <span style={{ fontSize: '11px', color: '#888', display: 'inline-block', transform: isOpen ? 'rotate(180deg)' : 'rotate(0)' }}>▼</span>
                  </div>
                </div>

                {/* BODY CMD */}
                {isOpen && (
                  <div style={{ borderTop: '1px solid #2A2A2A' }}>
                    {/* TRACKER */}
                    <div style={{ padding: '18px 22px', display: 'flex', alignItems: 'flex-start' }}>
                      {stepLabels.map((label, i) => (
                        <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', zIndex: 1 }}>
                          {i < stepLabels.length - 1 && (
                            <div style={{ position: 'absolute', top: '15px', left: '50%', right: '-50%', height: '3px', background: i < currentStep ? '#F5620A' : '#2A2A2A', zIndex: 0 }}></div>
                          )}
                          <div style={{ width: '30px', height: '30px', borderRadius: '50%', border: `2.5px solid ${i <= currentStep ? '#F5620A' : '#333'}`, background: i < currentStep ? '#F5620A' : '#1C1C1C', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px', position: 'relative', zIndex: 2, flexShrink: 0, boxShadow: i === currentStep ? '0 0 0 4px rgba(245,98,10,.2)' : 'none' }}>
                            {i < currentStep ? '✓' : stepIcons[i]}
                          </div>
                          <div style={{ fontSize: '10px', fontWeight: '700', color: i <= currentStep ? '#F5620A' : '#888', textAlign: 'center', marginTop: '7px', lineHeight: '1.3', maxWidth: '68px' }}>{label}</div>
                        </div>
                      ))}
                    </div>

                    {/* DETAILS */}
                    <div style={{ padding: '0 22px 16px', display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '10px' }}>
                      {[
                        { label: 'DELAI', val: cmd.delai, orange: true },
                        { label: 'ADRESSE', val: cmd.adresse_livraison || 'N/A' },
                        { label: 'STATUT', val: sc.label },
                      ].map((d, i) => (
                        <div key={i} style={{ background: '#141414', borderRadius: '8px', padding: '9px 12px' }}>
                          <div style={{ fontSize: '9px', fontWeight: '700', color: '#888', letterSpacing: '.4px', marginBottom: '2px' }}>{d.label}</div>
                          <div style={{ fontSize: '12px', fontWeight: '700', color: d.orange ? '#F5620A' : '#fff' }}>{d.val}</div>
                        </div>
                      ))}
                    </div>

                    {/* ACTIONS */}
                    <div style={{ padding: '0 22px 16px', display: 'flex', gap: '7px', flexWrap: 'wrap' }}>
                      {cmd.statut !== 'livre' && cmd.statut !== 'annule' && (
                        <button onClick={() => confirmerReception(cmd.id)} style={{ padding: '8px 16px', background: '#22C55E', border: 'none', borderRadius: '8px', fontSize: '12px', fontWeight: '800', color: '#fff', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                          ✓ Confirmer la reception
                        </button>
                      )}
                      {cmd.statut === 'livre' && (
                        <>
                          <Link to={`/produit/${cmd.annonce_id}`}>
                            <button style={{ padding: '8px 14px', background: 'transparent', border: '1.5px solid #333', borderRadius: '8px', fontSize: '12px', fontWeight: '700', color: '#888', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>🔁 Commander a nouveau</button>
                          </Link>
                          <button style={{ padding: '8px 14px', background: 'transparent', border: `1.5px solid #F0B429`, borderRadius: '8px', fontSize: '12px', fontWeight: '700', color: '#F0B429', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>⭐ Evaluer</button>
                        </>
                      )}
                      {cmd.statut !== 'livre' && cmd.statut !== 'annule' && (
                        <button style={{ padding: '8px 14px', background: 'transparent', border: '1.5px solid #EF4444', borderRadius: '8px', fontSize: '12px', fontWeight: '700', color: '#EF4444', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                          ⚠ Signaler un probleme
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default DashboardAcheteur;